import { ITableConfig, TableColumnType, UITableColumnCellType } from '@shared/ui';

export const tableConfig: ITableConfig = {
  paginationType: 'server-side',
  columns: [
    {
      type: TableColumnType.Order,
      width: '70px',
    },
    {
      title: 'Название',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'name',
        isTranslatable: true,
      },
      subName: {
        type: UITableColumnCellType.Text,
        fieldName: 'operator.name',
        isTranslatable: true,
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Адрес',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'address',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Время работы',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'workingHours.open',
      },
      subName: {
        type: UITableColumnCellType.Text,
        fieldName: 'workingHours.close',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Парковочные места',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'totalSpots',
      },
      type: TableColumnType.Basic,
    },
    {
      type: TableColumnType.Actions,
      width: '100px',
      buttons: [
        {
          type: 'edit',
        },
        {
          type: 'delete',
        },
      ],
      align: 'right',
    },
  ],
};
